/**
 * @generated SignedSource<<ae0d5dc3befd8f17509aa7ce9605e968>>
 * @relayHash 3cb94abe8af191ae4d08600236042e5c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/580.0.0-2026-10-07T07:45:34.775Z/nftPublicProfileEntryQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nftPublicProfileEntryQuery$variables = {
  collectionCursor?: string | null;
  collectionFirst?: number | null;
  creationsCursor?: string | null;
  creationsFirst?: number | null;
  draftsCursor?: string | null;
  draftsFirst?: number | null;
  fetchDrafts?: boolean | null;
  fetchUser: boolean;
  hasTokenContractId?: boolean | null;
  liveAuctionsCursor?: string | null;
  liveAuctionsFirst?: number | null;
  liveBidsCursor?: string | null;
  liveBidsFirst?: number | null;
  lostBidsCursor?: string | null;
  lostBidsFirst?: number | null;
  tokenContractId?: string | null;
  userId: string;
  username: string;
  walletAddress?: string | null;
};
export type nftPublicProfileEntryQuery$data = {
  readonly viewer: {
    readonly collection: {
      readonly totalResults: number | null;
    } | null;
    readonly collectionAndCreations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly metadata: {
            readonly media?: {
              readonly mimeType: string | null;
              readonly posterFrameUrl: string | null;
              readonly videoThumb: string | null;
              readonly webUrl: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly creations: {
      readonly totalResults: number | null;
    } | null;
    readonly draftItems?: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "NftItemDraftsByCreatorEdge";
      } | null> | null;
    } | null;
    readonly liveAuctions: {
      readonly totalResults: number | null;
    } | null;
    readonly liveBids: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "NftAuctionsByBidderEdge";
      } | null> | null;
    } | null;
    readonly lostBids: {
      readonly edges: ReadonlyArray<{
        readonly __typename: "NftAuctionsByBidderEdge";
      } | null> | null;
    } | null;
    readonly nftTokenContractImportById?: {
      readonly collectionDescription: string | null;
      readonly collectionName: string | null;
    } | null;
    readonly publicProfile: {
      readonly bio: string | null;
      readonly displayName: string | null;
      readonly heroImage: {
        readonly parent: {
          readonly path: string | null;
        } | null;
        readonly path: string | null;
      } | null;
      readonly userId: string | null;
      readonly username: string | null;
    } | null;
    readonly selling: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly metadata: {
            readonly media?: {
              readonly mimeType: string | null;
              readonly posterFrameUrl: string | null;
              readonly videoThumb: string | null;
              readonly webUrl: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly tokenImports: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"importCollectionsConfig_contractImport">;
        } | null;
      } | null> | null;
      readonly totalResults: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftHeaderLayout_viewer" | "NftPublicProfileRespLayout_viewer">;
  };
};
export type nftPublicProfileEntryQuery = {
  response: nftPublicProfileEntryQuery$data;
  variables: nftPublicProfileEntryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collectionCursor"
},
v1 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "collectionFirst"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "creationsCursor"
},
v3 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "creationsFirst"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "draftsCursor"
},
v5 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "draftsFirst"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchDrafts"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "hasTokenContractId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "liveAuctionsCursor"
},
v10 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "liveAuctionsFirst"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "liveBidsCursor"
},
v12 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "liveBidsFirst"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lostBidsCursor"
},
v14 = {
  "defaultValue": 20,
  "kind": "LocalArgument",
  "name": "lostBidsFirst"
},
v15 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "tokenContractId"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v18 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "walletAddress"
},
v19 = {
  "kind": "Variable",
  "name": "username",
  "variableName": "username"
},
v20 = [
  (v19/*:: as any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v26 = [
  {
    "kind": "Variable",
    "name": "tokenContractId",
    "variableName": "tokenContractId"
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionName",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionDescription",
  "storageKey": null
},
v29 = {
  "items": [
    {
      "kind": "Variable",
      "name": "creatorAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "creatorAddresses"
},
v30 = {
  "items": [
    {
      "kind": "Variable",
      "name": "creatorProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "creatorProfileUsernames"
},
v31 = {
  "kind": "Literal",
  "name": "onlyFirstdibsContracts",
  "value": true
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v33 = [
  (v32/*:: as any*/)
],
v34 = {
  "alias": "creations",
  "args": [
    (v29/*:: as any*/),
    (v30/*:: as any*/),
    (v31/*:: as any*/)
  ],
  "concreteType": "NftItemSearchConnection",
  "kind": "LinkedField",
  "name": "nftItemSearch",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": null
},
v35 = {
  "kind": "Literal",
  "name": "excludeOwnerCreatedItems",
  "value": true
},
v36 = {
  "items": [
    {
      "kind": "Variable",
      "name": "ownerAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "ownerAddresses"
},
v37 = {
  "items": [
    {
      "kind": "Variable",
      "name": "ownerProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "ownerProfileUsernames"
},
v38 = {
  "alias": "collection",
  "args": [
    (v35/*:: as any*/),
    (v36/*:: as any*/),
    (v37/*:: as any*/)
  ],
  "concreteType": "NftItemSearchConnection",
  "kind": "LinkedField",
  "name": "nftItemSearch",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": null
},
v39 = {
  "items": [
    {
      "kind": "Variable",
      "name": "auctionSellerAddresses.0",
      "variableName": "walletAddress"
    }
  ],
  "kind": "ListValue",
  "name": "auctionSellerAddresses"
},
v40 = {
  "items": [
    {
      "kind": "Variable",
      "name": "auctionSellerProfileUsernames.0",
      "variableName": "username"
    }
  ],
  "kind": "ListValue",
  "name": "auctionSellerProfileUsernames"
},
v41 = {
  "alias": "liveAuctions",
  "args": [
    (v39/*:: as any*/),
    (v40/*:: as any*/),
    (v35/*:: as any*/)
  ],
  "concreteType": "NftItemSearchConnection",
  "kind": "LinkedField",
  "name": "nftItemSearch",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": null
},
v42 = {
  "kind": "Variable",
  "name": "bidderAddress",
  "variableName": "walletAddress"
},
v43 = {
  "kind": "Literal",
  "name": "status",
  "value": "BIDDER_LIVE"
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v45 = [
  (v44/*:: as any*/)
],
v46 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v45/*:: as any*/),
    "storageKey": null
  }
],
v47 = {
  "alias": "liveBids",
  "args": [
    (v42/*:: as any*/),
    (v43/*:: as any*/),
    (v19/*:: as any*/)
  ],
  "concreteType": "NftAuctionsByBidderConnection",
  "kind": "LinkedField",
  "name": "nftAuctionsByBidder",
  "plural": false,
  "selections": (v46/*:: as any*/),
  "storageKey": null
},
v48 = {
  "kind": "Literal",
  "name": "status",
  "value": "BIDDER_LOST"
},
v49 = {
  "alias": "lostBids",
  "args": [
    (v42/*:: as any*/),
    (v48/*:: as any*/),
    (v19/*:: as any*/)
  ],
  "concreteType": "NftAuctionsByBidderConnection",
  "kind": "LinkedField",
  "name": "nftAuctionsByBidder",
  "plural": false,
  "selections": (v46/*:: as any*/),
  "storageKey": null
},
v50 = {
  "kind": "Variable",
  "name": "creatorAddress",
  "variableName": "walletAddress"
},
v51 = [
  (v50/*:: as any*/),
  (v19/*:: as any*/)
],
v52 = {
  "alias": "draftItems",
  "args": (v51/*:: as any*/),
  "concreteType": "NftItemDraftsByCreatorConnection",
  "kind": "LinkedField",
  "name": "nftItemDraftsByCreator",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItemDraftsByCreatorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": (v45/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importStatus",
  "storageKey": null
},
v55 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_ERROR"
  ]
},
v56 = {
  "alias": "errored",
  "args": [
    (v55/*:: as any*/)
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
},
v57 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_PROCESSING"
  ]
},
v58 = {
  "alias": "processing",
  "args": [
    (v57/*:: as any*/)
  ],
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
},
v59 = {
  "kind": "Literal",
  "name": "importStatuses",
  "value": [
    "NFT_ITEM_IMPORT_STATUS_COMPLETE"
  ]
},
v60 = [
  (v59/*:: as any*/)
],
v61 = {
  "alias": "completed",
  "args": (v60/*:: as any*/),
  "concreteType": "NftTokenContractImportCreatedItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": (v33/*:: as any*/),
  "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
},
v62 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v63 = [
  {
    "kind": "Literal",
    "name": "excludeOwnerCreatedItems",
    "value": false
  },
  (v62/*:: as any*/),
  (v36/*:: as any*/),
  (v37/*:: as any*/)
],
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "NftDigitalArtMetadataMedia",
  "kind": "LinkedField",
  "name": "media",
  "plural": false,
  "selections": [
    (v64/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "posterFrameUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoThumb",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v65/*:: as any*/)
  ],
  "type": "NftDigitalArtMetadata",
  "abstractKey": null
},
v67 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftItemSearchEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              (v66/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v68 = [
  (v39/*:: as any*/),
  (v40/*:: as any*/),
  (v62/*:: as any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ensDomain",
  "storageKey": null
},
v72 = [
  (v53/*:: as any*/),
  (v70/*:: as any*/)
],
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v74 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "collectionCursor"
  },
  (v35/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "collectionFirst"
  },
  (v36/*:: as any*/),
  (v37/*:: as any*/)
],
v75 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v44/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v73/*:: as any*/),
        (v65/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "edition",
          "storageKey": null
        }
      ],
      "type": "NftDigitalArtMetadata",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v76 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v78 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "currentBid",
  "plural": false,
  "selections": (v78/*:: as any*/),
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherAmount",
  "kind": "LinkedField",
  "name": "reservePrice",
  "plural": false,
  "selections": (v78/*:: as any*/),
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v70/*:: as any*/)
  ],
  "storageKey": null
},
v82 = [
  (v69/*:: as any*/),
  (v81/*:: as any*/),
  (v71/*:: as any*/),
  (v70/*:: as any*/)
],
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "winnerAddress",
  "plural": false,
  "selections": (v82/*:: as any*/),
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v85 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "EtherRates",
  "kind": "LinkedField",
  "name": "etherRates",
  "plural": true,
  "selections": (v85/*:: as any*/),
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "NftConversionRateEvent",
  "kind": "LinkedField",
  "name": "endedConversionRates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "rates",
      "plural": true,
      "selections": (v85/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = [
  (v69/*:: as any*/),
  (v70/*:: as any*/)
],
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "creatorAddress",
  "plural": false,
  "selections": (v89/*:: as any*/),
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "sellerAddress",
  "plural": false,
  "selections": (v89/*:: as any*/),
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": (v76/*:: as any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": [
    (v77/*:: as any*/),
    (v79/*:: as any*/),
    (v80/*:: as any*/),
    (v83/*:: as any*/),
    (v84/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftItem",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        (v86/*:: as any*/),
        (v70/*:: as any*/),
        (v87/*:: as any*/)
      ],
      "storageKey": null
    },
    (v88/*:: as any*/),
    (v90/*:: as any*/),
    (v91/*:: as any*/),
    (v70/*:: as any*/)
  ],
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wasBurned",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v25/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importErrorReason",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "NftItemLikes",
  "kind": "LinkedField",
  "name": "likes",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "likeCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicProfileUrl",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "creatorAddress",
  "plural": false,
  "selections": [
    (v97/*:: as any*/),
    (v81/*:: as any*/),
    (v70/*:: as any*/),
    (v69/*:: as any*/)
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalSupply",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isERC1155",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "ownerAddress",
  "plural": false,
  "selections": (v82/*:: as any*/),
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenId",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenUri",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "NftTokenContract",
  "kind": "LinkedField",
  "name": "contract",
  "plural": false,
  "selections": [
    (v73/*:: as any*/),
    (v70/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "addressWithFields",
      "plural": false,
      "selections": (v89/*:: as any*/),
      "storageKey": null
    },
    (v69/*:: as any*/)
  ],
  "storageKey": null
},
v105 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "balanceForUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        },
        (v70/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ownerAddress",
          "plural": false,
          "selections": (v89/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "contractAddress",
  "plural": false,
  "selections": (v89/*:: as any*/),
  "storageKey": null
},
v107 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v77/*:: as any*/),
  (v106/*:: as any*/),
  (v70/*:: as any*/)
],
v108 = {
  "alias": "recentAuction",
  "args": (v76/*:: as any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": (v107/*:: as any*/),
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v109 = {
  "alias": "auction",
  "args": (v76/*:: as any*/),
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "mostRecentAuction",
  "plural": false,
  "selections": (v107/*:: as any*/),
  "storageKey": "mostRecentAuction(excludeCanceled:true)"
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v112 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftItemSearchEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v53/*:: as any*/),
          (v75/*:: as any*/),
          (v92/*:: as any*/),
          (v93/*:: as any*/),
          (v94/*:: as any*/),
          (v95/*:: as any*/),
          (v70/*:: as any*/),
          (v96/*:: as any*/),
          (v98/*:: as any*/),
          (v99/*:: as any*/),
          (v100/*:: as any*/),
          (v101/*:: as any*/),
          (v102/*:: as any*/),
          (v103/*:: as any*/),
          (v104/*:: as any*/),
          (v105/*:: as any*/),
          (v108/*:: as any*/),
          (v87/*:: as any*/),
          (v109/*:: as any*/),
          (v44/*:: as any*/)
        ],
        "storageKey": null
      },
      (v110/*:: as any*/)
    ],
    "storageKey": null
  },
  (v111/*:: as any*/)
],
v113 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "liveAuctionsCursor"
  },
  (v39/*:: as any*/),
  (v40/*:: as any*/),
  (v35/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "liveAuctionsFirst"
  }
],
v114 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "creationsCursor"
  },
  (v29/*:: as any*/),
  (v30/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "creationsFirst"
  },
  (v31/*:: as any*/)
],
v115 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "liveBidsCursor"
  },
  (v42/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "liveBidsFirst"
  },
  (v43/*:: as any*/),
  (v19/*:: as any*/)
],
v116 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftAuctionsByBidderEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftAuctionBidderRef",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bidDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EtherAmount",
            "kind": "LinkedField",
            "name": "bidAmount",
            "plural": false,
            "selections": (v78/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EthereumAddressType",
            "kind": "LinkedField",
            "name": "bidderAddress",
            "plural": false,
            "selections": (v89/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NftAuction",
            "kind": "LinkedField",
            "name": "auction",
            "plural": false,
            "selections": [
              (v84/*:: as any*/),
              (v70/*:: as any*/),
              (v77/*:: as any*/),
              (v79/*:: as any*/),
              (v80/*:: as any*/),
              (v83/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItem",
                "kind": "LinkedField",
                "name": "item",
                "plural": false,
                "selections": [
                  (v86/*:: as any*/),
                  (v70/*:: as any*/),
                  (v87/*:: as any*/),
                  (v53/*:: as any*/),
                  (v75/*:: as any*/),
                  (v93/*:: as any*/),
                  (v94/*:: as any*/),
                  (v95/*:: as any*/),
                  (v96/*:: as any*/),
                  (v98/*:: as any*/),
                  (v99/*:: as any*/),
                  (v100/*:: as any*/),
                  (v101/*:: as any*/),
                  (v102/*:: as any*/),
                  (v103/*:: as any*/),
                  (v104/*:: as any*/),
                  (v105/*:: as any*/),
                  (v108/*:: as any*/),
                  (v109/*:: as any*/)
                ],
                "storageKey": null
              },
              (v88/*:: as any*/),
              (v90/*:: as any*/),
              (v91/*:: as any*/)
            ],
            "storageKey": null
          },
          (v70/*:: as any*/),
          (v44/*:: as any*/)
        ],
        "storageKey": null
      },
      (v110/*:: as any*/)
    ],
    "storageKey": null
  },
  (v111/*:: as any*/)
],
v117 = [
  "username",
  "bidderAddress",
  "status"
],
v118 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "lostBidsCursor"
  },
  (v42/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "lostBidsFirst"
  },
  (v48/*:: as any*/),
  (v19/*:: as any*/)
],
v119 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NftItemSearchEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              (v44/*:: as any*/),
              (v66/*:: as any*/)
            ],
            "storageKey": null
          },
          (v70/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v120 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "draftsCursor"
  },
  (v50/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "draftsFirst"
  },
  (v19/*:: as any*/)
],
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalUrl",
  "storageKey": null
},
v122 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v123 = [
  (v122/*:: as any*/),
  (v55/*:: as any*/)
],
v124 = [
  (v32/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "NftTokenContractImportCreatedItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NftItem",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v53/*:: as any*/),
          (v95/*:: as any*/),
          (v75/*:: as any*/),
          (v92/*:: as any*/),
          (v93/*:: as any*/),
          (v94/*:: as any*/),
          (v70/*:: as any*/),
          (v96/*:: as any*/),
          (v98/*:: as any*/),
          (v99/*:: as any*/),
          (v100/*:: as any*/),
          (v101/*:: as any*/),
          (v102/*:: as any*/),
          (v103/*:: as any*/),
          (v104/*:: as any*/),
          (v105/*:: as any*/),
          (v108/*:: as any*/),
          (v87/*:: as any*/),
          (v109/*:: as any*/),
          (v44/*:: as any*/)
        ],
        "storageKey": null
      },
      (v110/*:: as any*/)
    ],
    "storageKey": null
  },
  (v111/*:: as any*/)
],
v125 = [
  "importStatuses"
],
v126 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v127 = [
  (v126/*:: as any*/),
  (v55/*:: as any*/)
],
v128 = [
  (v122/*:: as any*/),
  {
    "kind": "Literal",
    "name": "importStatuses",
    "value": [
      "NFT_ITEM_IMPORT_STATUS_COMPLETE",
      "NFT_ITEM_IMPORT_STATUS_PROCESSING"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "nftPublicProfileEntryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftPublicProfileRespLayout_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftHeaderLayout_viewer"
          },
          {
            "alias": null,
            "args": (v20/*:: as any*/),
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "heroImage",
                "plural": false,
                "selections": [
                  (v25/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Photo",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v25/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "hasTokenContractId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v26/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  (v27/*:: as any*/),
                  (v28/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v34/*:: as any*/),
          (v38/*:: as any*/),
          (v41/*:: as any*/),
          (v47/*:: as any*/),
          (v49/*:: as any*/),
          {
            "condition": "fetchDrafts",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v52/*:: as any*/)
            ]
          },
          {
            "alias": "tokenImports",
            "args": (v51/*:: as any*/),
            "concreteType": "NftTokenContractImportsConnection",
            "kind": "LinkedField",
            "name": "nftTokenContractImports",
            "plural": false,
            "selections": [
              (v32/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContractImportsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "importCollectionsConfig_contractImport",
                        "selections": [
                          (v53/*:: as any*/),
                          (v54/*:: as any*/),
                          (v56/*:: as any*/),
                          (v58/*:: as any*/),
                          (v61/*:: as any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "collectionAndCreations",
            "args": (v63/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v67/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "selling",
            "args": (v68/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v67/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v17/*:: as any*/),
      (v16/*:: as any*/),
      (v7/*:: as any*/),
      (v18/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v10/*:: as any*/),
      (v9/*:: as any*/),
      (v12/*:: as any*/),
      (v11/*:: as any*/),
      (v14/*:: as any*/),
      (v13/*:: as any*/),
      (v5/*:: as any*/),
      (v4/*:: as any*/),
      (v6/*:: as any*/),
      (v15/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "nftPublicProfileEntryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v20/*:: as any*/),
            "concreteType": "PublicProfile",
            "kind": "LinkedField",
            "name": "publicProfile",
            "plural": false,
            "selections": [
              (v21/*:: as any*/),
              (v23/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "walletAddress",
                "plural": false,
                "selections": [
                  (v69/*:: as any*/),
                  (v70/*:: as any*/),
                  (v71/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "avatarImage",
                "plural": false,
                "selections": [
                  (v25/*:: as any*/),
                  (v70/*:: as any*/),
                  (v53/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Photo",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": (v72/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Photo",
                "kind": "LinkedField",
                "name": "heroImage",
                "plural": false,
                "selections": [
                  (v25/*:: as any*/),
                  (v70/*:: as any*/),
                  (v53/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Photo",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v53/*:: as any*/),
                      (v70/*:: as any*/),
                      (v25/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v22/*:: as any*/),
              (v24/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "webLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discordLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagramLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "facebookLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wikipediaLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitterLink",
                "storageKey": null
              },
              (v70/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          (v34/*:: as any*/),
          (v38/*:: as any*/),
          (v41/*:: as any*/),
          (v47/*:: as any*/),
          (v49/*:: as any*/),
          {
            "alias": "tokenImports",
            "args": (v51/*:: as any*/),
            "concreteType": "NftTokenContractImportsConnection",
            "kind": "LinkedField",
            "name": "nftTokenContractImports",
            "plural": false,
            "selections": [
              (v32/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContractImportsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v53/*:: as any*/),
                      (v54/*:: as any*/),
                      (v56/*:: as any*/),
                      (v58/*:: as any*/),
                      (v61/*:: as any*/),
                      (v70/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "collection",
                    "args": null,
                    "concreteType": "NftTokenContractImport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v53/*:: as any*/),
                      {
                        "alias": "incompleteItems",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "importStatuses",
                            "value": [
                              "NFT_ITEM_IMPORT_STATUS_ERROR",
                              "NFT_ITEM_IMPORT_STATUS_PROCESSING"
                            ]
                          }
                        ],
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": (v33/*:: as any*/),
                        "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                      },
                      (v54/*:: as any*/),
                      (v56/*:: as any*/),
                      (v58/*:: as any*/),
                      (v61/*:: as any*/),
                      (v27/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftTokenContract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": [
                          (v73/*:: as any*/),
                          (v70/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 4
                          },
                          {
                            "kind": "Literal",
                            "name": "importStatuses",
                            "value": [
                              "NFT_ITEM_IMPORT_STATUS_COMPLETE",
                              "NFT_ITEM_IMPORT_STATUS_PROCESSING",
                              "NFT_ITEM_IMPORT_STATUS_ERROR"
                            ]
                          }
                        ],
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": [
                          (v32/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftTokenContractImportCreatedItemsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftItem",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v53/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                      (v44/*:: as any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "NftDigitalArtMetadataMedia",
                                            "kind": "LinkedField",
                                            "name": "media",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": "poster",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "posterFrameUrl",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "web",
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "webUrl",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "NftDigitalArtMetadata",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v70/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "items(first:4,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\",\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                      },
                      {
                        "alias": "completeItems",
                        "args": (v60/*:: as any*/),
                        "concreteType": "NftTokenContractImportCreatedItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": (v33/*:: as any*/),
                        "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                      },
                      (v70/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v70/*:: as any*/),
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          },
          {
            "alias": null,
            "args": (v74/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v112/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v74/*:: as any*/),
            "filters": [
              "ownerProfileUsernames",
              "ownerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCollection_nftItemSearch",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "nftsForSale",
            "args": (v113/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v112/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "nftsForSale",
            "args": (v113/*:: as any*/),
            "filters": [
              "auctionSellerProfileUsernames",
              "auctionSellerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionAuctions_nftsForSale",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "nftCreations",
            "args": (v114/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v112/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "nftCreations",
            "args": (v114/*:: as any*/),
            "filters": [
              "creatorProfileUsernames",
              "creatorAddresses",
              "onlyFirstdibsContracts"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCreations_nftCreations",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          {
            "alias": "bidderLiveBids",
            "args": (v115/*:: as any*/),
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v116/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "bidderLiveBids",
            "args": (v115/*:: as any*/),
            "filters": (v117/*:: as any*/),
            "handle": "connection",
            "key": "NftProfileSectionLiveBids_bidderLiveBids",
            "kind": "LinkedHandle",
            "name": "nftAuctionsByBidder"
          },
          {
            "alias": "bidderLostBids",
            "args": (v118/*:: as any*/),
            "concreteType": "NftAuctionsByBidderConnection",
            "kind": "LinkedField",
            "name": "nftAuctionsByBidder",
            "plural": false,
            "selections": (v116/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "bidderLostBids",
            "args": (v118/*:: as any*/),
            "filters": (v117/*:: as any*/),
            "handle": "connection",
            "key": "NftProfileSectionLostBids_bidderLostBids",
            "kind": "LinkedHandle",
            "name": "nftAuctionsByBidder"
          },
          {
            "alias": null,
            "args": (v26/*:: as any*/),
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImportById",
            "plural": false,
            "selections": (v72/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "nftMintBlogEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftMintBlog"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftMintBlog\")"
          },
          {
            "alias": "nftSearchEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftSearch"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftSearch\")"
          },
          {
            "alias": "collectionAndCreations",
            "args": (v63/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v119/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "selling",
            "args": (v68/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": (v119/*:: as any*/),
            "storageKey": null
          },
          {
            "condition": "fetchDrafts",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v52/*:: as any*/),
              {
                "alias": "drafts",
                "args": (v120/*:: as any*/),
                "concreteType": "NftItemDraftsByCreatorConnection",
                "kind": "LinkedField",
                "name": "nftItemDraftsByCreator",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItemDraftsByCreatorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItemDraft",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v53/*:: as any*/),
                          (v73/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editionNumber",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editionTotal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftMedia",
                            "kind": "LinkedField",
                            "name": "mainMedia",
                            "plural": false,
                            "selections": [
                              (v64/*:: as any*/),
                              (v121/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "videoThumbUrl",
                                "storageKey": null
                              },
                              (v70/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftMedia",
                            "kind": "LinkedField",
                            "name": "posterFrameMedia",
                            "plural": false,
                            "selections": [
                              (v64/*:: as any*/),
                              (v121/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayUrl",
                                "storageKey": null
                              },
                              (v70/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "modifiedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ethereumWalletAddress",
                                "plural": false,
                                "selections": [
                                  (v97/*:: as any*/),
                                  (v70/*:: as any*/),
                                  (v81/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v70/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v70/*:: as any*/),
                          (v44/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v110/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v111/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "drafts",
                "args": (v120/*:: as any*/),
                "filters": [
                  "username",
                  "creatorAddress"
                ],
                "handle": "connection",
                "key": "NftProfileSectionDrafts_drafts",
                "kind": "LinkedHandle",
                "name": "nftItemDraftsByCreator"
              }
            ]
          },
          {
            "condition": "hasTokenContractId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "nftTokenContractImportErrors",
                "args": (v26/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v123/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v124/*:: as any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v123/*:: as any*/),
                    "filters": (v125/*:: as any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v70/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v26/*:: as any*/),
                "concreteType": "NftTokenContractImport",
                "kind": "LinkedField",
                "name": "nftTokenContractImportById",
                "plural": false,
                "selections": [
                  {
                    "alias": "errorItems",
                    "args": (v127/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v33/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": null,
                    "args": (v128/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v124/*:: as any*/),
                    "storageKey": "items(first:20,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": null,
                    "args": (v128/*:: as any*/),
                    "filters": (v125/*:: as any*/),
                    "handle": "connection",
                    "key": "NftProfileImportCollectionViewNftList_items",
                    "kind": "LinkedHandle",
                    "name": "items"
                  },
                  (v54/*:: as any*/),
                  (v106/*:: as any*/),
                  (v27/*:: as any*/),
                  (v28/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContract",
                    "kind": "LinkedField",
                    "name": "contract",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenStandard",
                        "storageKey": null
                      },
                      (v70/*:: as any*/),
                      (v73/*:: as any*/),
                      (v69/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "symbol",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "processingItems",
                    "args": [
                      (v126/*:: as any*/),
                      (v57/*:: as any*/)
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v33/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_PROCESSING\"])"
                  },
                  {
                    "alias": "completeItems",
                    "args": [
                      (v126/*:: as any*/),
                      (v59/*:: as any*/)
                    ],
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v33/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
                  },
                  {
                    "alias": "failedItems",
                    "args": (v127/*:: as any*/),
                    "concreteType": "NftTokenContractImportCreatedItemsConnection",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": false,
                    "selections": (v33/*:: as any*/),
                    "storageKey": "items(first:0,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
                  },
                  {
                    "alias": "description",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectionDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/580.0.0-2026-10-07T07:45:34.775Z/nftPublicProfileEntryQuery",
    "metadata": {},
    "name": "nftPublicProfileEntryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1a7bc7bbad8e53a722db5afb14e6f7f5";

export default node;
